import React, { useEffect, useState } from "react";
import "./Cateringsreport.css";
import { useLoader } from "../../../context/LoaderProvider"; // ✅ import loader context
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
function Cateringsreport() {
    const [orders, setOrders] = useState([]);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [selectedDate, setSelectedDate] = useState(""); // Stores selected date (YYYY-MM-DD)
    const { showLoader, hideLoader } = useLoader(); // ✅ get global loader functions
    useEffect(() => {
        const token = localStorage.getItem("authToken");
        const vendorId = localStorage.getItem("vendorId");

        if (!token) {
            console.error("No auth token found in localStorage!");
            return;
        }

        const fetchOrders = async () => {
            try {
                showLoader();
                const res = await fetch(
                    `https://backend.maamaas.com/catering/api/vendor/${vendorId}`,
                    {
                        method: "GET",
                        headers: {
                            Accept: "*/*",
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
                const jsonData = await res.json();

                // ✅ Only show masked leads
                const maskedOrders = jsonData.data?.fullLeads || [];
                setOrders(maskedOrders);
                setFilteredOrders(maskedOrders);
            } catch (err) {
                console.error("Error fetching orders:", err);
            }
            hideLoader();
        };

        fetchOrders();
    }, []);
    const exportToExcel = () => {
        if (filteredOrders.length === 0) {
            alert("No data to export!");
            return;
        }

        // 1️⃣ Prepare Excel data
        const excelData = filteredOrders.map((item, index) => ({
            "S.No": index + 1,
            "Order ID": item.id,
            "User ID": item.userId,
            "Location": item.city || "-",
            "Date": item.eventDate
                ? new Date(item.eventDate).toLocaleDateString("en-GB").replace(/\//g, ".")
                : "-",
            "Time": item.eventTime || "-",
            "Event Type": item.eventType || "-",
            "Veg Plates": item.vegPlates || "-",
            "Non-Veg Plates": item.nonVegPlates || "-",
            "Mixed Plates": item.mixedPlates || "-",
            "Lead Price": item.leadPrice || 0,
        }));

        // 2️⃣ Convert data to worksheet
        const worksheet = XLSX.utils.json_to_sheet(excelData);

        // 3️⃣ Create workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Catering Report");

        // 4️⃣ Generate Excel file
        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        // 5️⃣ Save file
        const file = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(file, `Catering_Report_${new Date().toISOString().split("T")[0]}.xlsx`);
    };


    // Filter by selected date
    useEffect(() => {
        if (!selectedDate) {
            setFilteredOrders(orders);
        } else {
            showLoader();
            const filtered = orders.filter((order) => {
                if (!order.eventDate) return false;
                const eventDate = new Date(order.eventDate);
                const yyyy = eventDate.getFullYear();
                const mm = String(eventDate.getMonth() + 1).padStart(2, "0");
                const dd = String(eventDate.getDate()).padStart(2, "0");
                return `${yyyy}-${mm}-${dd}` === selectedDate;
            });
            setFilteredOrders(filtered);
            hideLoader();
        }
    }, [selectedDate, orders]);

    return (
        <div>

            <div style={{ overflowX: "auto" }} className="reports-cateringtable">
                {/* 📅 Date filter section */}
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        flexWrap: "wrap",
                        gap: "10px",
                        marginBottom: "10px",
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <input
                            type="date"
                            value={selectedDate}
                            onChange={(e) => setSelectedDate(e.target.value)}
                            style={{
                                padding: "6px 10px",
                                fontSize: "14px",
                                background: "#b15dc6",
                                color: "#fff",
                                border: "none",
                                borderRadius: "5px",
                                cursor: "pointer",
                            }}
                        />

                        {selectedDate && (
                            <button
                                onClick={() => setSelectedDate("")}
                                style={{
                                    padding: "6px 10px",
                                    backgroundColor: "#b15dc6",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                }}
                            >
                                Clear
                            </button>
                        )}
                    </div>

                    <button
                        onClick={exportToExcel}
                        style={{
                            padding: "8px 14px",
                            background: "#b15dc6",
                            color: "#fff",
                            border: "none",
                            borderRadius: "5px",
                            cursor: "pointer",
                            fontSize: "14px",
                        }}
                    >
                        Export to Excel
                    </button>
                </div>



                {/* 📊 Table section */}
                <table
                    style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        marginTop: "15px",
                        fontSize: "14px",
                    }}
                >
                    <thead>
                        <tr style={{ backgroundColor: "rgb(177 93 198)", color: "white" }}>
                            <th>Order ID</th>
                            <th>User ID</th>
                            <th>Location</th>
                            <th>Date</th>
                            <th>Time</th>
                            <th>Event Type</th>
                            <th>Veg Plates</th>
                            <th>Non-Veg Plates</th>
                            <th>Mixed Plates</th>
                            <th>Lead Price</th>
                        </tr>
                    </thead>

                    <tbody>
                        {filteredOrders.length > 0 ? (
                            filteredOrders.map((order) => {
                                const dateObj = new Date(order.createdAt);
                                const time = dateObj.toLocaleTimeString("en-IN", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true,
                                });

                                return (
                                    <tr key={order.id}>
                                        <td style={tdStyle}>{order.id}</td>
                                        <td style={tdStyle}>{order.userId}</td>
                                        <td style={tdStyle}>{order.city || "-"}</td>
                                        <td style={tdStyle}>
                                            {order.eventDate
                                                ? new Date(order.eventDate)
                                                    .toLocaleDateString("en-GB")
                                                    .replace(/\//g, ".")
                                                : "-"}
                                        </td>
                                        <td style={tdStyle}>{order.eventTime || time || "-"}</td>
                                        <td style={tdStyle}>{order.eventType || "-"}</td>
                                        <td style={tdStyle}>{order.vegPlates || "-"}</td>
                                        <td style={tdStyle}>{order.nonVegPlates || "-"}</td>
                                        <td style={tdStyle}>{order.mixedPlates || "-"}</td>
                                        <td style={tdStyle}>{order.leadPrice || 0}</td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td
                                    colSpan="10"
                                    style={{
                                        textAlign: "center",
                                        padding: "10px",
                                        color: "#666",
                                    }}
                                >
                                    No leads found for selected date
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>

                {/* 📦 Export button at end of table */}

            </div>

        </div>
    );
}

// Styles
const tdStyle = {
    border: "1px solid #ccc",
    padding: "6px",
    textAlign: "center",
};

export default Cateringsreport;
